import React, { useMemo } from 'react';
import LoadingSpinner from '@/components/atoms/loading-spinner/loading-spinner';
import { Button, ButtonSizeType, ButtonStyleType, ICourse } from '@into-discovery/browsewebshared';
import SearchResultsRow from '@/components/organisms/search-results-row/search-results-row';
import colorStyles from '@/styles/utils/variables.module.scss';
import styles from './search-results.module.scss';

type Props = {
  searchQueryId: string;
  courses: ICourse[];
  loadNextPage: () => void;
  isDataLoading: boolean;
  isNextPageAvailable: boolean;
  totalCourses: number;
  defaultPageSize: number;
  isBreakpointLgUp: boolean;
  isBreakpointMediumUp: boolean;
};

export default function SearchResults({
  searchQueryId,
  courses,
  loadNextPage,
  isDataLoading,
  isNextPageAvailable,
  totalCourses,
  defaultPageSize,
  isBreakpointLgUp,
  isBreakpointMediumUp,
}: Props) {
  const renderData = useMemo(() => {
    const nextSetOfProgramCount =
      totalCourses - courses.length > defaultPageSize
        ? defaultPageSize
        : totalCourses - courses.length;
    return { nextSetOfProgramCount };
  }, [courses, defaultPageSize, totalCourses]);

  if (!courses?.length) {
    return <p>No programs found</p>;
  }

  return (
    <>
      <div className={`${styles.results}`}>
        {courses.map((course, index) => (
          <SearchResultsRow
            key={`${course.mainProgram.outcomeId}-${course.mainProgram.id}`}
            course={course}
            searchQueryId={searchQueryId}
            searchPosition={index + 1}
            isBreakpointLgUp={isBreakpointLgUp}
            isBreakpointMediumUp={isBreakpointMediumUp}
          />
        ))}
      </div>
      {(isNextPageAvailable || isDataLoading) && (
        <div className="d-flex justify-content-center align-items-center mt-3">
          {!isDataLoading && (
            <Button
              buttonID="show-more-search-results"
              buttonAriaLabel="show more search results"
              buttonName="show more search results"
              buttonStyle={ButtonStyleType.Outline}
              buttonSize={ButtonSizeType.Medium}
              copyColor={colorStyles.primary}
              outlineColor={colorStyles.primary}
              backgroundColor={colorStyles.white}
              hoverBackgroundColor={colorStyles.primaryHover}
              activeBackgroundColor={colorStyles.primaryActive}
              onClick={loadNextPage}
              buttonRole="button"
            >
              Show {renderData.nextSetOfProgramCount} more
            </Button>
          )}
          {isDataLoading && <LoadingSpinner />}
        </div>
      )}
    </>
  );
}
